import { DateTime } from 'luxon';

export const MIN_DATE = DateTime.local().minus({ month: 1 });
export const MAX_DATE = DateTime.local().plus({ years: 2 }).endOf('year');
export const DAY_PARSE_FORMAT = 'yyyy-MM-dd';
